module.exports = __webpack_public_path__ + "img/231.edf65e24.png";